
import { Component, Prop, PropSync, Vue } from 'vue-property-decorator'
import Project from "@/types/project/project"
import Tracking from "@/types/tracking/tracking"
import VueI18n from "vue-i18n"
import LocaleMessage = VueI18n.LocaleMessage
import TrackingFields from "@/components/Tracking/TrackingFields.vue"
import ConfirmDialog from "@/components/ConfirmDialog.vue"
import { TrackingService } from "@/services/timetrack/TrackingService"
import { ExpenditureService } from "@/services/timetrack/ExpenditureService"
import DateDialog from "@/components/DateAndTime/DateDialog.vue"
import TimeDialog from "@/components/DateAndTime/TimeDialog.vue"
import { DateAndTimeHelper } from "@/helpers/DateAndTimeHelper"
import FlipClock from "@/components/FlipClock.vue"
import DateEndDialog from "@/components/DateAndTime/DateEndDialog.vue"
import TimeEndDialog from "@/components/DateAndTime/TimeEndDialog.vue"

@Component({
  filters: {
  },
  components: {
    TimeEndDialog,
    DateEndDialog,
    FlipClock,
    ConfirmDialog,
    TrackingFields,
    DateDialog,
    TimeDialog
  }
})
export default class CompleteTracking extends Vue {
  private loading = false
  private dateDialog = false
  private dateEndDialog = false
  private timeDialog = false
  private timeEndDialog = false
  private confirmDiscardTracking = false

  private trackingService = new TrackingService()
  private expenditureService = new ExpenditureService()
  private dateAndTimeHelper = new DateAndTimeHelper()

  @PropSync('dialog', { type: Boolean }) completeDialog!: boolean;

  @Prop({ required: true, default: null })
  private projects!: Project[];

  @Prop({ required: true, default: null })
  private tracking!: Tracking;

  @Prop({ required: true, default: null })
  private tasks!: string[] | LocaleMessage[];

  @Prop({ required: true, default: null })
  private making!: string;

  @PropSync('making', { type: String }) currentMaking!: string;

  private get trackedTime () {
    if (!this.tracking || !this.tracking.startingTime || !this.tracking.endTime) return
    return this.dateAndTimeHelper.getTrackedTime(this.tracking.startingTime, Number(this.tracking.endTime))
  }

  private get trackingComplete () {
    return this.tracking &&
      this.tracking.task &&
      this.tracking.startingTime &&
      this.tracking.endTime &&
      this.tracking.projectId
  }

  private discardTracking () {
    this.loading = true
    this.removeExpendituresForTracking()
  }

  private removeExpendituresForTracking () {
    if (this.tracking && this.tracking.id && this.tracking.expenditures && this.tracking.expenditures.length < 1) {
      this.expenditureService.removeExpendituresForTracking(this.tracking.id)
        .then(() => {
          this.removeTracking()
        }).catch((error) => {
          this.$store.dispatch('error/setError', error)
        }).finally(() => {
          this.loading = false
        })
    } else {
      this.removeTracking()
    }
  }

  private removeTracking () {
    if (!this.tracking || !this.tracking.id) return
    this.trackingService.removeCurrentTracking(this.tracking.id)
      .then(() => {
        this.$emit('trackingChanged')
      }).catch((error) => {
        this.$store.dispatch('error/setError', error)
      }).finally(() => {
        this.loading = false
      })
  }

  private updateStartingDate (startingDate: number) {
    if (!this.tracking || !this.tracking.startingTime) return
    const newDate = this.dateAndTimeHelper.getNewMillisecondsDate(this.tracking.startingTime, startingDate)
    this.$emit('changedDate', newDate)
    this.dateDialog = false
  }

  private updateStartingTime (startingTime: string) {
    if (!this.tracking || !this.tracking.startingTime) return
    const startedAtDateAndTime = this.dateAndTimeHelper.getMillisecondsFromTimeValue(this.tracking.startingTime, startingTime)
    this.$emit('changedTime', startedAtDateAndTime)
    this.timeDialog = false
  }

  private updateEndingDate (endingDate: number) {
    if (!this.tracking || !this.tracking.endTime) return
    const newDate = this.dateAndTimeHelper.getNewMillisecondsDate(Number(this.tracking.endTime), endingDate)
    this.$emit('changedEndDate', newDate)
    this.dateEndDialog = false
  }

  private updateEndingTime (endingTime: string) {
    if (!this.tracking || !this.tracking.endTime) return
    const endedAtDateAndTime = this.dateAndTimeHelper.getMillisecondsFromTimeValue(Number(this.tracking.endTime), endingTime)
    this.$emit('changedEndTime', endedAtDateAndTime)
    this.timeEndDialog = false
  }
}
